import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Badge } from "./ui/badge";
import { Trophy, Target, TrendingUp } from "lucide-react";

interface PlayerStatsProps {
  gamesPlayed: number;
  gamesWon: number;
  gamesLost: number;
  gamesDrawn: number;
  eloRating: number;
}

export function PlayerStats({ 
  gamesPlayed, 
  gamesWon, 
  gamesLost, 
  gamesDrawn, 
  eloRating 
}: PlayerStatsProps) {
  const winRate = gamesPlayed > 0 ? Math.round((gamesWon / gamesPlayed) * 100) : 0;

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-lg flex items-center gap-2">
            <Trophy className="w-5 h-5 text-primary" />
            ELO Rating
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-primary">{eloRating}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-lg flex items-center gap-2">
            <Target className="w-5 h-5 text-primary" />
            Win Rate
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold text-primary">{winRate}%</div>
          <div className="text-sm text-muted-foreground mt-1">
            {gamesWon} wins out of {gamesPlayed} games
          </div>
        </CardContent>
      </Card>

      <Card className="md:col-span-2">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-primary" />
            Game Record
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-4 flex-wrap">
            <div className="flex items-center gap-2">
              <Badge variant="default" className="bg-green-500 hover:bg-green-600">
                Wins: {gamesWon}
              </Badge>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="default" className="bg-red-500 hover:bg-red-600">
                Losses: {gamesLost}
              </Badge>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="secondary">
                Draws: {gamesDrawn}
              </Badge>
            </div>
            <div className="flex items-center gap-2">
              <Badge variant="outline">
                Total: {gamesPlayed}
              </Badge>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
